import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { useNavigate } from "react-router-dom";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

function ProjectCard({ project }) {
  const navigate = useNavigate();
  const [shortDescription, setShortDescription] = useState("");

  useEffect(() => {
    async function fetchDescription() {
      try {
        const projectRef = doc(db, "projects", project.id);
        const projectSnap = await getDoc(projectRef);
        if (projectSnap.exists()) {
          const data = projectSnap.data();
          const description = data.project_description || "";
          setShortDescription(
            description.length > 100
              ? `${description.substring(0, 100)}...`
              : description
          );
        }
      } catch (error) {
        console.error("Açıklama alınırken hata:", error);
      }
    }
    fetchDescription();
  }, [project.id]);

  const firstImage =
    project.image_urls && project.image_urls.length > 0
      ? project.image_urls[0]
      : "https://via.placeholder.com/300x180?text=No+Image";

  return (
    <div style={styles.card} onClick={() => navigate(`/project/${project.id}`)}>
      <img src={firstImage} alt={project.project_name || "Proje"} style={styles.image} />
      <div style={styles.content}>
        <h3 style={styles.title}>{project.project_name || "Proje Adı"}</h3>
        
        {/* Konum bilgisi - üstte */}
        <div style={styles.locationContainer}>
          <svg style={styles.icon} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="#555" />
          </svg>
          <p style={styles.location}>{project.city || "Şehir Belirtilmemiş"}</p>
        </div>

        {/* Fiyat bilgisi - ayrı satırda */}
<div style={styles.priceContainer}>
  {project.price ? (
    (() => {
      const formatted = formatPrice(project.price);

      if (!formatted) return "Fiyat Belirtilmemiş";

      if (formatted.type === "starting") {
        return (
          <p style={styles.price}>
            {formatted.value}{" "}
            <span style={styles.startingText}>
              ile başlayan fiyatlarla
            </span>
          </p>
        );
      }

      return <p style={styles.price}>{formatted.value}</p>;
    })()
  ) : (
    "Fiyat Belirtilmemiş"
  )}
</div>


        {shortDescription && <p style={styles.description}>{shortDescription}</p>}
      </div>
    </div>
  );
}

function formatPrice(price) {
  if (!price) return null;

  // Eğer price string ise ve TL içeriyorsa
  if (typeof price === "string") {
    if (price.includes("TL") || price.includes("₺")) {
      return { value: price, type: "normal" };
    }

    const numericPrice = price.replace(/[^\d]/g, "");
    if (numericPrice) {
      return { value: `${numericPrice} TL`, type: "normal" };
    }
  }

  // Eğer price number ise
  if (typeof price === "number") {
    return {
      value: price.toLocaleString("tr-TR"),
      type: "starting",
    };
  }

  return null;
}


export default function AllProjects() {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const projectsPerPage = 9;

  const [selectedCity, setSelectedCity] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [deliveryYear, setDeliveryYear] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [districts, setDistricts] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [pageGroup, setPageGroup] = useState(0);

  const navigate = useNavigate();

  const cityDistricts = {
    "İstanbul": ["Adalar", "Arnavutköy", "Ataşehir", "Avcılar", "Bağcılar", "Bahçelievler", "Bakırköy", "Başakşehir", "Bayrampaşa", "Beşiktaş", "Beykoz", "Beylikdüzü", "Beyoğlu", "Büyükçekmece", "Çatalca", "Çekmeköy", "Esenler", "Esenyurt", "Eyüpsultan", "Fatih", "Gaziosmanpaşa", "Güngören", "Kadıköy", "Kağıthane", "Kartal", "Küçükçekmece", "Maltepe", "Pendik", "Sancaktepe", "Sarıyer", "Silivri", "Sultanbeyli", "Sultangazi", "Şile", "Şişli", "Tuzla", "Ümraniye", "Üsküdar", "Zeytinburnu"],
    "Ankara": ["Altındağ", "Akyurt", "Ayaş", "Bala", "Beypazarı", "Çamlıdere", "Çankaya", "Çubuk", "Elmadağ", "Etimesgut", "Evren", "Gölbaşı", "Güdül", "Haymana", "Kalecik", "Kahramankazan", "Keçiören", "Kızılcahamam", "Mamak", "Nallıhan", "Polatlı", "Pursaklar", "Sincan", "Şereflikoçhisar", "Yenimahalle"],
    "İzmir": ["Aliağa", "Balçova", "Bayındır", "Bayraklı", "Bergama", "Beydağ", "Bornova", "Buca", "Çeşme", "Çiğli", "Dikili", "Foça", "Gaziemir", "Güzelbahçe", "Karabağlar", "Karaburun", "Karşıyaka", "Kemalpaşa", "Kınık", "Kiraz", "Konak", "Menderes", "Menemen", "Narlıdere", "Ödemiş", "Seferihisar", "Selçuk", "Tire", "Torbalı", "Urla"]
  };

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    async function fetchProjects() {
      setLoading(true);
      try {
        const querySnapshot = await getDocs(collection(db, "projects"));
        const fetchedProjects = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProjects(fetchedProjects);
        setFilteredProjects(fetchedProjects);
      } catch (error) {
        console.error("Projeler alınırken hata:", error);
      }
      setLoading(false);
    }

    fetchProjects();
  }, []);

  useEffect(() => {
    if (selectedCity) {
      setDistricts(cityDistricts[selectedCity] || []);
    } else {
      setDistricts([]);
      setSelectedDistrict("");
    }
  }, [selectedCity]);

  const applyFilters = () => {
    let filtered = [...projects];
    if (selectedCity) filtered = filtered.filter(p => p.city === selectedCity);
    if (selectedDistrict) filtered = filtered.filter(p => p.district === selectedDistrict);
    if (deliveryYear) filtered = filtered.filter(p => p.delivery_date && p.delivery_date.includes(deliveryYear));
    if (minPrice) filtered = filtered.filter(p => (parseFloat(p.price) || 0) >= parseFloat(minPrice));
    if (maxPrice) filtered = filtered.filter(p => (parseFloat(p.price) || Infinity) <= parseFloat(maxPrice));
    setFilteredProjects(filtered);
    setCurrentPage(1);
    setPageGroup(0);
    if (isMobile) {
      setShowFilters(false);
    }
  };

  const resetFilters = () => {
    setSelectedCity("");
    setSelectedDistrict("");
    setDeliveryYear("");
    setMinPrice("");
    setMaxPrice("");
    setFilteredProjects(projects);
    setCurrentPage(1);
    setPageGroup(0);
    if (isMobile) {
      setShowFilters(false);
    }
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);

  const totalPages = Math.ceil(filteredProjects.length / projectsPerPage);

  // Sayfa gruplama için değişkenler
  const pagesPerGroup = 3;
  const totalPageGroups = Math.ceil(totalPages / pagesPerGroup);
  const startPage = pageGroup * pagesPerGroup + 1;
  const endPage = Math.min(startPage + pagesPerGroup - 1, totalPages);
  const currentPages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    // Sayfa değiştiğinde sayfa grubunu da güncelle
    const newPageGroup = Math.floor((pageNumber - 1) / pagesPerGroup);
    setPageGroup(newPageGroup);
  };

  const nextPageGroup = () => {
    if (pageGroup < totalPageGroups - 1) {
      setPageGroup(pageGroup + 1);
      setCurrentPage((pageGroup + 1) * pagesPerGroup + 1);
    }
  };

  const prevPageGroup = () => {
    if (pageGroup > 0) {
      setPageGroup(pageGroup - 1);
      setCurrentPage((pageGroup - 1) * pagesPerGroup + pagesPerGroup);
    }
  };

  if (loading) return <div style={styles.loading}>Projeler yükleniyor...</div>;
  if (projects.length === 0) return <div style={styles.noProjects}>Hiç proje bulunamadı.</div>;

  return (
    <div style={{...styles.mainContainer, ...(isMobile && styles.mobileMainContainer)}}>
      {/* Mobile Filter Toggle Button */}
      {isMobile && (
        <div style={styles.mobileFilterHeader}>
          <button style={styles.mobileFilterToggle} onClick={toggleFilters}>
            <svg style={styles.filterIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 21V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M4 10V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 21V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 8V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M20 21V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M20 12V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M1 14H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9 8H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M17 16H23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Filtrele
            {showFilters ? (
              <svg style={styles.chevronIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <svg style={styles.chevronIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </button>
        </div>
      )}

      {/* Filters Sidebar */}
      {(showFilters || !isMobile) && (
        <div style={{
          ...styles.sidebar, 
          ...(isMobile && styles.mobileSidebar),
          ...(isMobile && showFilters && styles.mobileSidebarOpen)
        }}>
          <h3 style={styles.filterTitle}>Filtrele</h3>

          <div style={styles.filterSection}>
            <h4 style={styles.filterSubtitle}>Şehir</h4>
            <select 
              style={{...styles.filterSelect, ...(isMobile && styles.mobileSelect)}}
              value={selectedCity}
              onChange={(e) => setSelectedCity(e.target.value)}
            >
              <option value="">Tüm Şehirler</option>
              <option value="İstanbul">İstanbul</option>
              <option value="Ankara">Ankara</option>
              <option value="İzmir">İzmir</option>
            </select>
          </div>

          <div style={styles.filterSection}>
            <h4 style={styles.filterSubtitle}>İlçe</h4>
            <select 
              style={{...styles.filterSelect, ...(isMobile && styles.mobileSelect)}}
              value={selectedDistrict}
              onChange={(e) => setSelectedDistrict(e.target.value)}
              disabled={!selectedCity}
            >
              <option value="">Tüm İlçeler</option>
              {districts.map(d => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>

          <div style={styles.filterSection}>
            <h4 style={styles.filterSubtitle}>Teslim Tarihi</h4>
            <select 
              style={{...styles.filterSelect, ...(isMobile && styles.mobileSelect)}}
              value={deliveryYear}
              onChange={(e) => setDeliveryYear(e.target.value)}
            >
              <option value="">Tüm Yıllar</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
              <option value="2028">2027</option>
            </select>
          </div>

          <div style={styles.filterSection}>
            <h4 style={styles.filterSubtitle}>Fiyat Aralığı</h4>
            <div style={styles.priceRange}>
              <input 
                type="number" 
                placeholder="Min" 
                style={{...styles.priceInput, ...(isMobile && styles.mobilePriceInput)}} 
                value={minPrice}
                onChange={(e) => setMinPrice(e.target.value)}
              />
              <span style={styles.priceSeparator}>-</span>
              <input 
                type="number" 
                placeholder="Max" 
                style={{...styles.priceInput, ...(isMobile && styles.mobilePriceInput)}} 
                value={maxPrice}
                onChange={(e) => setMaxPrice(e.target.value)}
              />
            </div>
          </div>

          <div style={styles.buttonGroup}>
            <button style={styles.filterButton} onClick={applyFilters}>Filtrele</button>
            <button style={styles.resetButton} onClick={resetFilters}>Sıfırla</button>
          </div>
        </div>
      )}

      {/* Overlay for mobile when filters are open */}
      {isMobile && showFilters && (
        <div style={styles.overlay} onClick={() => setShowFilters(false)} />
      )}

      <div style={styles.contentContainer}>
        <h2 style={styles.header}>Tüm Projeler</h2>
        <div style={{...styles.grid, ...(isMobile && styles.mobileGrid)}}>
          {currentProjects.map(project => <ProjectCard key={project.id} project={project} />)}
        </div>

        {/* Sayfalama - Mobil ve Desktop için farklı */}
        {isMobile ? (
          <div style={styles.mobilePagination}>
            {/* Önceki grup butonu */}
            <button
              onClick={prevPageGroup}
              disabled={pageGroup === 0}
              style={{
                ...styles.navButton,
                ...(pageGroup === 0 && styles.disabledNavButton)
              }}
            >
              <svg style={styles.navIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 6L9 12L15 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            {/* Sayfa numaraları */}
            {currentPages.map(pageNumber => (
              <button
                key={pageNumber}
                onClick={() => paginate(pageNumber)}
                style={{
                  ...styles.mobilePageButton,
                  ...(currentPage === pageNumber && styles.activeMobilePageButton),
                }}
              >
                {pageNumber}
              </button>
            ))}

            {/* Sonraki grup butonu */}
            <button
              onClick={nextPageGroup}
              disabled={pageGroup >= totalPageGroups - 1}
              style={{
                ...styles.navButton,
                ...(pageGroup >= totalPageGroups - 1 && styles.disabledNavButton)
              }}
            >
              <svg style={styles.navIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        ) : (
          <div style={styles.pagination}>
            {Array.from({length: totalPages}).map((_, index) => (
              <button
                key={index}
                onClick={() => paginate(index + 1)}
                style={{
                  ...styles.pageButton,
                  ...(currentPage === index + 1 && styles.activePageButton),
                }}
              >
                {index + 1}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  mainContainer: {
    display: "flex",
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "20px",
    gap: "30px",
  },
  mobileMainContainer: {
    flexDirection: "column",
    padding: "15px",
  },
  mobileFilterHeader: {
    width: "100%",
    marginBottom: "15px",
  },
  mobileFilterToggle: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    padding: "12px 16px",
    backgroundColor: "#2a9d8f",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  },
  filterIcon: {
    width: "20px",
    height: "20px",
  },
  chevronIcon: {
    width: "18px",
    height: "18px",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 998,
  },
  sidebar: {
    width: "280px",
    backgroundColor: "#f8f9fa",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    height: "fit-content",
    position: "sticky",
    top: "20px",
  },
  mobileSidebar: {
    width: "80%",
    maxWidth: "320px",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 999,
    maxHeight: "80vh",
    overflowY: "auto",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  },
  mobileSidebarOpen: {
    animation: "slideIn 0.3s ease-out",
  },
  filterTitle: {
    color: "#2a9d8f",
    fontSize: "20px",
    marginBottom: "20px",
    paddingBottom: "10px",
    borderBottom: "1px solid #e0e0e0",
  },
  filterSubtitle: {
    fontSize: "16px",
    color: "#555",
    margin: "15px 0 10px 0",
  },
  filterSelect: {
    width: "100%",
    padding: "8px 12px",
    borderRadius: "6px",
    border: "1px solid #ddd",
    fontSize: "14px",
    backgroundColor: "#fff",
  },
  mobileSelect: {
    fontSize: "13px",
    padding: "6px 10px",
  },
  priceRange: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  priceInput: {
    flex: 1,
    padding: "11px 4px",
    borderRadius: "6px",
    border: "1px solid #ddd",
    fontSize: "10px",
  },
  mobilePriceInput: {
    fontSize: "12px",
    padding: "8px 4px",
  },
  priceSeparator: {
    color: "#777",
  },
  buttonGroup: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
  },
  filterButton: {
    flex: 1,
    padding: "10px",
    backgroundColor: "#2a9d8f",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
  },
  resetButton: {
    flex: 1,
    padding: "10px",
    backgroundColor: "#f8f9fa",
    color: "#555",
    border: "1px solid #ddd",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
  },
  contentContainer: {
    flex: 1,
  },
  header: {
    color: "#2a9d8f",
    fontSize: "28px",
    fontWeight: "600",
    marginBottom: "30px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "25px",
    marginLeft: "20px",
  },
  mobileGrid: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    marginLeft: "0",
  },
  card: {
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "#fff",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
  },
  image: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
    borderBottom: "1px solid #eee",
  },
  content: {
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  title: {
    fontSize: "20px",
    color: "#333",
    margin: 0,
    lineHeight: "1.3",
  },
  locationContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "4px",
  },
  priceContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  icon: {
    width: "16px",
    height: "16px",
    fill: "#555",
    flexShrink: 0,
  },
  location: {
    fontSize: "14px",
    color: "#777",
    margin: 0,
    fontWeight: "500",
  },
price: {
  fontSize: "16px",
  fontWeight: "bold",
  color: "#2a9d8f",
  margin: 0,
  textAlign: "left",
},

startingText: {
  fontSize: "12px",
  fontWeight: "normal",
  color: "#2a9d8f",
  marginLeft: "4px",
},

  description: {
    fontSize: "14px",
    color: "#555",
    lineHeight: "1.4",
    marginTop: "8px",
  },
  // Desktop sayfalama
  pagination: {
    marginTop: "30px",
    display: "flex",
    justifyContent: "center",
    gap: "8px",
  },
  pageButton: {
    padding: "8px 12px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    backgroundColor: "white",
    cursor: "pointer",
    fontSize: "14px",
  },
  activePageButton: {
    backgroundColor: "#2a9d8f",
    color: "white",
    borderColor: "#2a9d8f",
  },
  // Mobil sayfalama
  mobilePagination: {
    marginTop: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
  },
  mobilePageButton: {
    padding: "10px 14px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    backgroundColor: "white",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    minWidth: "40px",
  },
  activeMobilePageButton: {
    backgroundColor: "#2a9d8f",
    color: "white",
    borderColor: "#2a9d8f",
  },
  navButton: {
    padding: "10px 12px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    backgroundColor: "white",
    cursor: "pointer",
    color: "#2a9d8f",
  },
  disabledNavButton: {
    backgroundColor: "#f8f9fa",
    color: "#ccc",
    cursor: "not-allowed",
    borderColor: "#e0e0e0",
  },
  navIcon: {
    width: "16px",
    height: "16px",
  },
  loading: {
    padding: "50px",
    textAlign: "center",
    fontSize: "20px",
  },
  noProjects: {
    padding: "50px",
    textAlign: "center",
    fontSize: "20px",
    color: "#999",
  },
};

// CSS animation for mobile sidebar
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(`
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translate(-50%, -45%);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }
`, styleSheet.cssRules.length);

// Mobil kartlar için özel stil
const mobileCardStyle = {
  width: "80%",
  margin: "0 auto",
};

// Mobil modda kartlara özel stil uygula
if (typeof window !== 'undefined' && window.innerWidth <= 768) {
  const style = document.createElement('style');
  style.textContent = `
    @media (max-width: 768px) {
      .project-card {
        width: 80% !important;
        margin: 0 auto !important;
      }
    }
  `;
  document.head.appendChild(style);
}